(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play/assets/javascripts/wallet-handler.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play/assets/javascripts/wallet-handler.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$components$tipse = svs.components.tipsen.wallet.actions,
  updatePlayerWalletBalance = _svs$components$tipse.updatePlayerWalletBalance,
  fetchMarketplaceRetailWallet = _svs$components$tipse.fetchMarketplaceRetailWallet,
  fetchMarketplacePlayerWallets = _svs$components$tipse.fetchMarketplacePlayerWallets,
  fetchPlayerWallet = _svs$components$tipse.fetchPlayerWallet,
  setActiveWallet = _svs$components$tipse.setActiveWallet;
const _svs$components$tipse2 = svs.components.tipsen.wallet.walletId,
  WALLET_ID_PLAYER = _svs$components$tipse2.WALLET_ID_PLAYER,
  WALLET_ID_MARKETPLACE_RETAILER = _svs$components$tipse2.WALLET_ID_MARKETPLACE_RETAILER;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _React = React,
  useEffect = _React.useEffect;
const useQueryParam = svs.components.lbUtils.useQueryParam;
const PARAM_MARKETPLACE_GAME_ID = svs.components.sport.tipsenShared.PARAM_MARKETPLACE_GAME_ID;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _RTK = RTK,
  isFulfilled = _RTK.isFulfilled,
  isAsyncThunkAction = _RTK.isAsyncThunkAction;
const userSession = svs.core.userSession;
const accountBalance = svs.components.account_balance;
const selectPlayerWalletBalance = svs.components.tipsen.walletSelectors.selectPlayerWalletBalance;
const groupTypes = svs.components.marketplaceData.constants.groupTypes;
const isPlayerWalletAction = isAsyncThunkAction(fetchPlayerWallet);
const WalletHandler = () => {
  const marketplaceGame = useQueryParam(PARAM_MARKETPLACE_GAME_ID);
  const dispatch = useDispatch();
  const _useCurrentDraw = useCurrentDraw(),
    productId = _useCurrentDraw.productId,
    drawNumber = _useCurrentDraw.drawNumber;
  const playerBalance = useSelector(selectPlayerWalletBalance);
  accountBalance.on('change', balance => {
    if (userSession.hasRole(userSession.roles.PLAYER) && playerBalance && balance !== playerBalance) {
      dispatch(updatePlayerWalletBalance(balance));
    }
  });
  useEffect(() => {
    const fetchWallets = async () => {
      if (userSession.hasRole(userSession.roles.PLAYER)) {
        const fetchWalletsPromises = [];
        const activatedDrawId = marketplaceGame ? parseInt(marketplaceGame, 10) : null;
        const role = groupTypes.PRIVATE;
        fetchWalletsPromises.push(dispatch(fetchMarketplacePlayerWallets({
          role,
          productId,
          drawNumber,
          activatedDrawId
        })));
        fetchWalletsPromises.push(dispatch(fetchPlayerWallet()));
        const _await$Promise$all = await Promise.all(fetchWalletsPromises),
          _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
          fetchMarketplaceWalletsResult = _await$Promise$all2[0],
          fetchPlayerWalletResult = _await$Promise$all2[1];
        if (marketplaceGame && isFulfilled(fetchMarketplaceWalletsResult)) {
          dispatch(setActiveWallet(marketplaceGame));
        } else if (isPlayerWalletAction(fetchPlayerWalletResult) && isFulfilled(fetchPlayerWalletResult)) {
          dispatch(setActiveWallet(WALLET_ID_PLAYER));
        }
      } else if (userSession.hasRole(userSession.roles.RETAILER) && marketplaceGame) {
        const result = await dispatch(fetchMarketplaceRetailWallet(marketplaceGame));
        if (isFulfilled(result)) {
          dispatch(setActiveWallet(WALLET_ID_MARKETPLACE_RETAILER));
        }
      }
    };
    fetchWallets();
  }, [dispatch, drawNumber, marketplaceGame, productId]);
  return null;
};
setGlobal('svs.components.tipsen.routePlay.WalletHandler', WalletHandler);

 })(window);